import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  infiniteListLoading: false,
  data: [],
  loading: false,
  error: null,
};

const productCategory = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.PRODUCT_CATEGORY_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        data: payload || [],
        loading: false,
        infiniteListLoading: false,
      };
    case actions.PRODUCT_CATEGORY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
        infiniteListLoading: false,
      };
    case actions.PRODUCT_CATEGORY_INFINITE_LIST_LOADING:
      return {
        ...state,
        infiniteListLoading: true,
      };
    default:
      return state;
  }
};

export default productCategory;
